import React, { Suspense } from 'react'
import { Routes, Route } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import Header from './components/Header'
import Footer from './components/Footer'
import LoadingSpinner from './components/LoadingSpinner'
import ScrollToTop from './components/ScrollToTop'
import StructuredData from './components/StructuredData'
import PerformanceOptimizer from './components/PerformanceOptimizer'


// Lazy loading ile sayfa bileşenlerini yükleme
const Home = React.lazy(() => import('./pages/Home'))
const Hakkimizda = React.lazy(() => import('./pages/Hakkimizda'))
const Hizmetler = React.lazy(() => import('./pages/Hizmetler'))
const Referanslar = React.lazy(() => import('./pages/Referanslar'))
const Iletisim = React.lazy(() => import('./pages/Iletisim'))
const HizmetAl = React.lazy(() => import('./pages/HizmetAl'))
const HizmetVer = React.lazy(() => import('./pages/HizmetVer'))

// Yeni eklenen sayfalar
const KullanimKosullari = React.lazy(() => import('./pages/KullanimKosullari'))
const SartlarKosullar = React.lazy(() => import('./pages/SartlarKosullar'))
const GizlilikPolitikasi = React.lazy(() => import('./pages/GizlilikPolitikasi'))
const CerezPolitikasi = React.lazy(() => import('./pages/CerezPolitikasi'))
const KVKK = React.lazy(() => import('./pages/KVKK'))
const OnlineOdeme = React.lazy(() => import('./pages/OnlineOdeme'))
const Partner = React.lazy(() => import('./pages/Partner'))
const AydinlatmaMetinleri = React.lazy(() => import('./pages/AydinlatmaMetinleri'))
const Politikalar = React.lazy(() => import('./pages/Politikalar'))
const Musteri = React.lazy(() => import('./pages/Musteri'))
const IsBasvuruSartlari = React.lazy(() => import('./pages/IsBasvuruSartlari'))
const KisiselVerilerKorunmasi = React.lazy(() => import('./pages/KisiselVerilerKorunmasi'))

// Sözleşme sayfaları
const SozlesmeMusteri = React.lazy(() => import('./pages/SozlesmeMusteri'))
const SozlesmePartner = React.lazy(() => import('./pages/SozlesmePartner'))

function App() {
  return (
    <div className="min-h-screen flex flex-col">
      <ScrollToTop />
      <StructuredData />
      <PerformanceOptimizer />
      <Header />
      <main className="flex-grow">
        <Suspense fallback={<LoadingSpinner />}>
          <HelmetProvider>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/hakkimizda" element={<Hakkimizda />} />
              <Route path="/hizmetler" element={<Hizmetler />} />
              <Route path="/referanslar" element={<Referanslar />} />
              <Route path="/iletisim" element={<Iletisim />} />
              <Route path="/hizmetal" element={<HizmetAl />} />
              <Route path="/hizmetver" element={<HizmetVer />} />
              <Route path="/hizmet-al" element={<HizmetAl />} />
              <Route path="/hizmet-ver" element={<HizmetVer />} />
              
              {/* Yeni eklenen sayfalar */}
              <Route path="/kullanim-kosullari" element={<KullanimKosullari />} />
              <Route path="/sartlar-kosullar" element={<SartlarKosullar />} />
              <Route path="/gizlilik-politikasi" element={<GizlilikPolitikasi />} />
              <Route path="/cerez-politikasi" element={<CerezPolitikasi />} />
              <Route path="/kvkk" element={<KVKK />} />
              <Route path="/online-odeme" element={<OnlineOdeme />} />
              <Route path="/partner" element={<Partner />} />
              <Route path="/aydinlatma-metinleri" element={<AydinlatmaMetinleri />} />
              <Route path="/politikalar" element={<Politikalar />} />
              <Route path="/musteri" element={<Musteri />} />
              <Route path="/is-basvuru-sartlari" element={<IsBasvuruSartlari />} />
              <Route path="/kisisel-veriler-korunmasi" element={<KisiselVerilerKorunmasi />} />

              {/* Sözleşme sayfaları */}
              <Route path="/sozlesmemusteri" element={<SozlesmeMusteri />} />
              <Route path="/sozlesmepartner" element={<SozlesmePartner />} />
            </Routes>
          </HelmetProvider>
        </Suspense>
      </main>
      <Footer />
    </div>
  )
}

export default App
